angular.module('impactx.rfx').service('RFXBuyerService', [
    'dataGen',
    'ToastService',
    'TranslationService',
    '$mdDialog',
    '$redirect',
    '$context',
    'OutsourcedCommentSaveService',
    'ConfirmationService',
    'LoadingDialogService',
    '$route',
    RFXBuyerService
]);

function RFXBuyerService(dataGen, ToastService, TranslationService, $mdDialog, $redirect, $context, OutsourcedCommentSaveService,
                         ConfirmationService, LoadingDialogService, $route) {

    function getDialogData(scope) {
        return dataGen.getData(scope, {rfqhId: scope.id, rfqcId: scope.rfqcId, supplierId: scope.preselectSupplierId}, '/rfx/buyer/view');
    }

    function saveInternal(tempScope, scope) {
        return dataGen.postAsForm(tempScope, {formData: scope.data}, '/rfx/buyer/save')
    }

    function saveData(tempScope, scope) {
        var extractedComments = OutsourcedCommentSaveService.extractComments(scope.data);
        return saveInternal(tempScope, scope).then(function (commentData) {
            if (commentData && commentData.data) {
                OutsourcedCommentSaveService.saveComments(commentData.data, extractedComments);
            }
        }, function () {
            OutsourcedCommentSaveService.restoreComments(scope.data, extractedComments);
        });
    }

    function saveDialogData(scope, redirectBack, config) {
        var extractedComments = OutsourcedCommentSaveService.extractComments(scope.data);
        var tempScope = {};
        var listRoute = '/rfxbuyerlist';
        var dialogRoute = 'rfxbuyer/';
        if(config) {
            listRoute = config.listRoute;
            dialogRoute = config.dialogRoute;
        }
        saveInternal(tempScope, scope).then(function (commentData) {
            var rfghId = scope.id > 0 ? scope.id : tempScope.data.rfqhId;
            if (commentData && commentData.data) {
                OutsourcedCommentSaveService.saveComments(commentData.data, extractedComments).then(
                    function () {
                        ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                        if (redirectBack) {
                            $redirect.redirectTo(null, listRoute);
                        }
                        else {
                            $redirect.redirectTo(null, dialogRoute + rfghId);
                        }
                    },
                    function () {
                        ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                        if (redirectBack) {
                            $redirect.redirectTo(null, listRoute);
                        }
                        else {
                            $redirect.redirectTo(null, dialogRoute + rfghId);
                        }
                    });
            }
            else
            {
                ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                if (redirectBack) {
                    $redirect.redirectTo(null, listRoute);
                }
                else {
                    $redirect.redirectTo(null, dialogRoute + rfghId);
                }
            }

        }, function () {
            OutsourcedCommentSaveService.restoreComments(scope.data, extractedComments);
        })
    }

    function saveDialogSupportData(scope, redirectBack)
    {
        const supportConfig = {
            listRoute: '/rfxrequestsupportlist',
            dialogRoute: 'rfx/requestsupport/'
        }
        saveDialogData(scope, redirectBack, supportConfig);
    }

    function saveAndRedirectToConversations(scope) {
        var extractedComments = OutsourcedCommentSaveService.extractComments(scope.data);
        saveInternal({}, scope).then(function (commentData) {
            if (commentData && commentData.data) {
                OutsourcedCommentSaveService.saveComments(commentData.data, extractedComments).then(
                    function () {
                        ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                        $redirect.redirectTo(null, 'rfxthread/buyer/' + scope.id);
                    },
                    function () {
                        ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                        $redirect.redirectTo(null, 'rfxthread/buyer/' + scope.id);
                    });
            }
            else
            {
                ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                $redirect.redirectTo(null, 'rfxthread/buyer/' + scope.id);
            }

        }, function () {
            OutsourcedCommentSaveService.restoreComments(scope.data, extractedComments);
        })
    }

    function saveAndRedirectToNewConversation(scope) {
        var extractedComments = OutsourcedCommentSaveService.extractComments(scope.data);
        saveInternal({}, scope).then(function (commentData) {
            if (commentData && commentData.data) {
                OutsourcedCommentSaveService.saveComments(commentData.data, extractedComments).then(
                    function () {
                        ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                        $redirect.redirectTo(null, 'rfxthread/edit/buyer/0/' + scope.id + '/false');
                    },
                    function () {
                        ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                        $redirect.redirectTo(null, 'rfxthread/edit/buyer/0/' + scope.id + '/false');
                    });
            }
            else
            {
                ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                $redirect.redirectTo(null, 'rfxthread/edit/buyer/0/' + scope.id + '/false');
            }

        }, function () {
            OutsourcedCommentSaveService.restoreComments(scope.data, extractedComments);
        })
    }

    function sendInternal(scope, id, reload) {
        if (id) {
            scope.data.id = id;
        }
        dataGen.postAsForm({}, {rfqhId: scope.data.id}, '/rfx/buyer/send').then(function () {
            scope.requestInProgress = false;
            LoadingDialogService.stop();
            ToastService.openStandardToast(scope.trns.sendSuccess);
            if (reload) {
                $route.reload();
            }
            else {
                $redirect.redirectTo(null, '/rfxbuyerlist');
            }
        }, function () {
            scope.requestInProgress = false;
            LoadingDialogService.stop();
        });
    }
    
    function sendDialogData(scope, reload) {
        scope.requestInProgress = true;
        var extractedComments = OutsourcedCommentSaveService.extractComments(scope.data);
        LoadingDialogService.start();
        saveInternal({}, scope).then(function (commentData) {
            if (commentData && commentData.data) {
                OutsourcedCommentSaveService.saveComments(commentData.data, extractedComments).then(function () {
                    sendInternal(scope, commentData.data.rfqhId, reload);
                });
            }
            else {
                sendInternal(scope, null, reload)
            }
        }, function () {
            scope.requestInProgress = false;
            LoadingDialogService.stop();
            OutsourcedCommentSaveService.restoreComments(scope.data, extractedComments);
        })
    }

    function sendAfterTextCustomization(scope) {
        LoadingDialogService.start();
        sendInternal(scope);
    }

    function saveDates(scope, reload) {
        return dataGen.postAsForm({}, {formData: scope.data}, '/rfx/buyer/savedates').then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            if (reload) {
                $route.reload();
            }
            else {
                $redirect.redirectTo(null, '/rfxbuyerlist');
            }
        })
    }

    function saveDatesAndRedirectToConversations(scope) {
        dataGen.postAsForm({}, {formData: scope.data}, '/rfx/buyer/savedates').then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            $redirect.redirectTo(null, 'rfxthread/buyer/' + scope.id);
        })
    }

    function saveDatesAndRedirectToNewConversation(scope) {
        dataGen.postAsForm({}, {formData: scope.data}, '/rfx/buyer/savedates').then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            $redirect.redirectTo(null, 'rfxthread/edit/buyer/0/' + scope.id + '/false');
        })
    }

    function saveUsers(scope) {
        if (scope.data.id > 0) {
            return dataGen.postAsForm({}, {formData: scope.data}, '/rfx/buyer/saveusers').then(function () {
                ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            })
        }
    }

    function showRevertDeletionToast(revertDeletionFunc) {
        return ToastService.openActionToast(TranslationService.get('deleteSuccess'), TranslationService.get('revert'), revertDeletionFunc);
    }

    function showEditPositionDialog(event, rfqhId, item, trns, smartFormTemplates) {
        if (item.isInformation) {
            return showEditInformationDialog(event, rfqhId, item, trns, false);
        }
        else if (item.isInternal) {
            return showEditInternalDialog(event, rfqhId, item, trns, false);
        }
        else if (item.smartForm && smartFormTemplates) {
            return openSmartFormItemDialog(event, smartFormTemplates, rfqhId, item, trns, false);
        }
        else {
            return showEditItemDialog(event, rfqhId, item, trns, false);
        }
    }

    function showViewPositionDialog(event, rfqhId, item, trns) {
        if (item.isInformation) {
            return showEditInformationDialog(event, rfqhId, item, trns, true);
        }
        else if (item.smartForm) {
            return openSmartFormItemDialog(event, undefined, rfqhId, item, trns, true);
        }
        else {
            return showEditItemDialog(event, rfqhId, item, trns, true);
        }
    }

    function getItemData(rfqhId, rfqiId, proId, sfiId, internal, amount) {
        var result = {};
        return dataGen.getData(result, {
            rfqhId: rfqhId,
            rfqiId: rfqiId,
            proId: proId || 0,
            sfiId: sfiId || 0,
            internal: internal || false,
            amount: amount
        }, '/rfx/buyer/item/view').then(function () {
            if (impactX.isDefined(result, 'data')) {
                return result.data;
            }
        })
    }

    function showEditInformationDialog(event, rfqhId, item, trns, readOnly) {
        return $mdDialog.show({
            controller: 'RFXEditInformationItemCtrl',
            controllerAs: 'rfxItemCtrl',
            templateUrl: 'modules/rfx/templates/rfx-edit-information-item.dialog.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            bindToController: true,
            locals: {
                rfqhId: rfqhId,
                item: item,
                trns: trns,
                readOnly: readOnly
            }
        });
    }

    function showEditInternalDialog(event, rfqhId, item, trns, readOnly) {
        return $mdDialog.show({
            controller: 'RFXEditInternalItemCtrl',
            controllerAs: 'rfxItemCtrl',
            templateUrl: 'modules/rfx/templates/rfx-edit-internal-item.dialog.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            bindToController: true,
            locals: {
                rfqhId: rfqhId,
                item: item,
                trns: trns,
                readOnly: readOnly
            }
        });
    }

    function showEditItemDialog(event, rfqhId, item, trns, readOnly) {
        var templateUrl;
        if (readOnly) {
            templateUrl = 'modules/rfx/templates/rfx-view-item.dialog.html';
        }
        else {
            templateUrl = 'modules/rfx/templates/rfx-edit-item.dialog.html';
        }

        return $mdDialog.show({
            controller: 'RFXEditItemCtrl',
            controllerAs: 'rfxItemCtrl',
            templateUrl: templateUrl,
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            bindToController: true,
            locals: {
                rfqhId: rfqhId,
                item: item,
                trns: trns,
                readOnly: readOnly
            }
        });
    }

    function openSmartFormItemDialog(event, smartFormTemplates, rfqhId, item, trns, readOnly) {
        var templateUrl;
        if (readOnly) {
            templateUrl = 'modules/rfx/templates/rfx-smart-form-item-viewer.dialog.html';
        }
        else {
            templateUrl = 'modules/rfx/templates/rfx-smart-form-item-buyer.dialog.html';
        }

        return $mdDialog.show({
            controller: 'RFXSmartFormItemCtrl',
            controllerAs: 'rfxSmartFormCtrl',
            templateUrl: templateUrl,
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            bindToController: true,
            locals: {
                smartFormTemplates: smartFormTemplates,
                rfqhId: rfqhId,
                item: item,
                trns: trns,
                readOnly: readOnly
            }
        });
    }

    function getSmartFormTemplateData(rfqhId, sftId) {
        return dataGen.getData({}, {rfqhId: rfqhId, sftId: sftId}, '/rfx/buyer/item/smartform');
    }

    function getRFQSItemData(rfqsId) {
        return dataGen.getData({}, {rfqsId: rfqsId}, '/rfx/offer/view');
    }

    function addToBasket(rfqhId, rfqsId, selectedIds) {
        dataGen.postAsForm({}, {rfqhId: rfqhId, rfqsId: rfqsId, selectedIds: selectedIds}, '/rfx/offer/addtobasket').then(function(result) {
            if (result && result.data.basketId > 0) {
                $context.refreshBasket({}, dataGen, $context);
                $redirect.redirectTo(null, '/basket');
                if (result.data.saveMessage) {
                    ToastService.openStandardToast(result.data.saveMessage);
                }
            }
        });
    }

    function showCancelDialog(event, rfqhId, trns, rework) {
        return $mdDialog.show({
            controller: 'RFXBuyerCancelCtrl',
            controllerAs: 'rfxBuyerCancelCtrl',
            templateUrl: 'modules/rfx/templates/rfx-buyer-cancel.dialog.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            bindToController: true,
            locals: {
                headerTrns: trns.cancel,
                reasonTrns: trns.reason,
                rfqhId: rfqhId,
                rework: rework,
                reasonHint: trns.cancelHint
            }
        });
    }

    function openOffers(event, rfqhId) {
        var question = TranslationService.get("openOffersQuestion") + '<br/>' +
            TranslationService.get("openOffersContinue")
        ConfirmationService.showConfirmationDialog(function () {
            $mdDialog.show({
                controller: 'RFXOpenOfferCtrl',
                controllerAs: 'rfxOpenOfferCtrl',
                templateUrl: 'modules/rfx/templates/rfx-open-offer.dialog.html',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                escapeToClose: false,
                bindToController: true,
                locals: {
                    rfqhId: rfqhId
                }
            }).then(function () {
                $redirect.redirectTo(null, "rfx/offers/" + rfqhId);
            });
        }, event, TranslationService.get("openOffers"), TranslationService.get("openOffers"),
            TranslationService.get("abort"), question);
    }

    var STATUS = {
        READY_FOR_PUBLISH: 12,
        DECIDED: 65,
        CANCELLED: 90,
        NO_ANSWER_CANCELLED: 95,
        REWORK: 97,
        NEW_ROUND: 102
    }

    function showTextCustomization(event, rfqhId, nextStatus, selectedRfqsIds) {
        return $mdDialog.show({
            controller: 'RFXTextCustomizationCtrl',
            controllerAs: 'rfxTextCustomizationCtrl',
            templateUrl: 'modules/rfx/templates/rfx-text-customization.dialog.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            escapeToClose: false,
            bindToController: true,
            locals: {
                rfqhId: rfqhId,
                nextStatus: nextStatus,
                selectedRfqsIds: selectedRfqsIds
            }
        });
    }

    function showNewRoundDialog(event, rfqhId) {
        return $mdDialog.show({
            controller: 'RFXNewRoundDialogCtrl',
            controllerAs: 'rfxNewRoundDialogCtrl',
            templateUrl: 'modules/rfx/templates/rfx-newround.dialog.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            escapeToClose: false,
            bindToController: true,
            locals: {
                rfqhId: rfqhId
            }
        });
    }

    function saveNewRound(event, data) {
        dataGen.postAsForm({}, {data: data}, "/rfx/buyer/newround/save").then(function (result) {
            if (result && result.data) {
                $redirect.redirectTo(null, '/rfxbuyer/' + result.data.rfqhId);
            }
        });
    }

    function addComparisonOffer(rfqhId) {
        var tempScope = {};
        dataGen.getData(tempScope, {rfqhId: rfqhId}, '/rfx/buyer/addComparisonOffer').then(function() {
            if (tempScope.data.rfqsId > 0) {
                $redirect.redirectTo(null, '/rfxsuppliereditbuyer/' + rfqhId + '/' + tempScope.data.rfqsId);
            }
        });
    }

    function decideEarly(rfqhId) {
        return dataGen.postAsForm({}, {rfqhId: rfqhId}, '/rfx/buyer/shortendeadlines');
    }

    function showReworkBeforeSend(event, rfqhId, title, question) {
        ConfirmationService.showConfirmationDialog(function () {
                dataGen.postAsForm({}, {id: rfqhId}, '/rfx/buyer/rework/beforeSend').then(function () {
                    $route.reload();
                });
            }, event, title, TranslationService.get("ok"),
            TranslationService.get("abort"), question);
    }

    return {
        STATUS: STATUS,
        getDialogData: getDialogData,
        saveDialogData: saveDialogData,
        saveDialogSupportData: saveDialogSupportData,
        saveData: saveData,
        saveAndRedirectToConversations: saveAndRedirectToConversations,
        saveAndRedirectToNewConversation: saveAndRedirectToNewConversation,
        sendDialogData: sendDialogData,
        saveDates: saveDates,
        saveDatesAndRedirectToConversations: saveDatesAndRedirectToConversations,
        saveDatesAndRedirectToNewConversation: saveDatesAndRedirectToNewConversation,
        saveUsers: saveUsers,
        showRevertDeletionToast: showRevertDeletionToast,
        showEditPositionDialog: showEditPositionDialog,
        showViewPositionDialog: showViewPositionDialog,
        openSmartFormItemDialog: openSmartFormItemDialog,
        getItemData: getItemData,
        getSmartFormTemplateData: getSmartFormTemplateData,
        getRFQSItemData: getRFQSItemData,
        addToBasket: addToBasket,
        showCancelDialog: showCancelDialog,
        openOffers: openOffers,
        showTextCustomization: showTextCustomization,
        sendAfterTextCustomization: sendAfterTextCustomization,
        showNewRoundDialog: showNewRoundDialog,
        saveNewRound: saveNewRound,
        addComparisonOffer: addComparisonOffer,
        decideEarly: decideEarly,
        showReworkBeforeSend: showReworkBeforeSend
    };
}